<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :rest_api_lite="rest_api_lite"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :back_href="'/building-areas'"
        :historiable="true"
    />    
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'AreaDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `areas/${this.$route.params.id}`,
            lite_rest_api:      `areas`,
            rest_api_lite:      `/areas`,
            rest_api_note:      `area_notes`,
            form_format:        FormResources.form_format,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {},
        }
    },

    methods:{

        fill_data(data) {
            this.single_object  = data.area;
            this.array_options = {
                building_id:    data.buildings,
                level_id:       [],
            }
            this.title_page     = this.single_object.name;
            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.name,
                href:   `/building-area/${this.parent_id}`,
                arrow:  "",
            });
        },

    },

    watch: {

        'single_object.frequency'(val)
        {
            if(val < 1 || val > 7)
            {
                this.single_object.frequency = 1
            }
        },
        
        async 'single_object.building_id'(val)
        {
            if(val)
            {
                 let http_request = {
                    id:             val,
                    level_request:  true,
                }
                const response = await this.get(`${this.lite_rest_api}/${JSON.stringify(http_request)}`);
                if(response.status) {
                    this.array_options.level_id = response.data.levels;
                } else {
                    this.error_handling(response)
                }
            }
        }
    },

    async mounted(){
        if(this.hasPermissions(['Building-Area Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    }
}
</script>